import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import s from './index.module.scss';

function MenuButton({ disableFromFocus }) {
  const dispatch = useDispatch();
  const menuOpened = useSelector((state) => state.global.menuOpened);
  const stateClass = menuOpened ? s.opened : '';

  function toggle() {
    dispatch({
      type: 'TOGGLE_MENU',
      payload: !menuOpened,
    });
  }

  return (
    <button className={`${s.menuButton} ${stateClass}`} type="button" onClick={toggle} tabIndex={disableFromFocus}>
      <span className={s.line1} />
      <span className={s.line2} />
      <span className={s.line3} />
    </button>
  );
}

export default MenuButton;
